import { createStore } from "solid-js/store";

interface DeeplinkRegistry {
	// Record<internal, external>
	registry: Record<
		string,
		{
			path: string;
			queryParams: string[];
			groupId: string;
		}
	>;
	// ISO string
	lastUpdate: string;
}

export const [deeplinkRegistryStore, setDeeplinkRegistryStore] = createStore<DeeplinkRegistry>(
	{
		registry: {},
		lastUpdate: "",
	},
	{
		name: "DeeplinkStore",
	},
);
